import React from "react";
import { Input, InputProps } from "semantic-ui-react";
import classNames from "classnames";
import { connectField, FieldProps } from "uniforms";

export type PercentageInputFieldProps = FieldProps<number, InputProps, { label?: string, className?: string, required?: boolean }>

export const PercentageInputField = ({
  disabled,
  id,
  inputRef,
  label,
  onChange,
  placeholder,
  required,
  error,
  className,
  value
}: PercentageInputFieldProps) => {
  return (
    <div className={classNames("field", { required, error }, className)}>
      <label htmlFor={id}>{label}</label>
      <Input
        id={id}
        disabled={disabled}
        ref={inputRef}
        placeholder={placeholder}
        onChange={(_, { value: updatedValue }) => {
          let val = Number(updatedValue) / 100;
          onChange(val);
        }}
        label="%"
        labelPosition="right"
        value={(value || 0) * 100}
        type={"number"}
      />
    </div>
  );
};

export default connectField<PercentageInputFieldProps>(PercentageInputField);
